<script setup lang="ts">
  import { reactiveOmit } from '@vueuse/core'
  import { ChevronDown } from 'lucide-vue-next'
  import {
    SelectIcon,
    SelectTrigger,
    type SelectTriggerProps,
    useForwardProps
  } from 'reka-ui'
  import type { HTMLAttributes } from 'vue'
  import { cn } from '../../../lib/utils'

  const props = withDefaults(
    defineProps<
      SelectTriggerProps & {
        class?: HTMLAttributes['class']
        size?: 'sm' | 'default'
      }
    >(),
    { size: 'default' }
  )

  const delegatedProps = reactiveOmit(props, 'class', 'size')
  const forwardedProps = useForwardProps(delegatedProps)
</script>

<template>
  <SelectTrigger
    data-slot="select-trigger"
    :data-size="size"
    v-bind="forwardedProps"
    :class="
      cn(
        `border-input data-[placeholder]:text-soft [&_svg:not([class*='text-'])]:text-soft focus-visible:border-ring focus-visible:ring-ring/50 aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive dark:bg-input/30 dark:hover:bg-input/50 shadow-xs flex w-fit items-center justify-between gap-2 whitespace-nowrap rounded-md border bg-transparent px-3 py-2 text-sm outline-none transition-[color,box-shadow] focus-visible:ring-[3px] disabled:cursor-not-allowed disabled:opacity-50 data-[size=default]:h-9 data-[size=sm]:h-8 *:data-[slot=select-value]:line-clamp-1 *:data-[slot=select-value]:flex *:data-[slot=select-value]:items-center *:data-[slot=select-value]:gap-2 [&_svg:not([class*='size-'])]:size-4 [&_svg]:pointer-events-none [&_svg]:shrink-0`,
        props.class
      )
    "
  >
    <slot />
    <SelectIcon as-child>
      <ChevronDown class="size-4 opacity-50" />
    </SelectIcon>
  </SelectTrigger>
</template>
